import React, { Component, createRef } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'

import {
  ChevronIcon2
} from './SVGIcons';

class App extends Component {
  constructor(props) {
    super(props)
    this.swiperRef = createRef()
    this.state = {
      isBeginning: true,
      isEnd: false,
      lightboxOpen: false,
      currentImageIndex: 0,
      isVideoModalOpen: false,
      photoLightboxSrc: null
    }
  }

  openVideoModal = () => {
    this.setState({ isVideoModalOpen: true })
  }

  closeVideoModal = () => {
    this.setState({ isVideoModalOpen: false })
  }

  getRutubeVideoId = (url) => {
    if (!url) return ''
    const match = url.match(/\/video\/([a-zA-Z0-9]+)/)
    return match ? match[1] : ''
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    })
  }

  openLightbox = (index) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: index
    })
    document.body.style.overflow = 'hidden'
  }

  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    })
    document.body.style.overflow = 'auto'
  }

  openPhotoLightbox = (src) => {
    this.setState({ photoLightboxSrc: src })
    document.body.style.overflow = 'hidden'
  }

  closePhotoLightbox = () => {
    this.setState({ photoLightboxSrc: null })
    document.body.style.overflow = 'auto'
  }

  nextImage = () => {
    const { images } = this.props.data || {}
    const { currentImageIndex } = this.state
    if (images && currentImageIndex < images.length - 1) {
      this.setState({ currentImageIndex: currentImageIndex + 1 })
    }
  }

  prevImage = () => {
    const { currentImageIndex } = this.state
    if (currentImageIndex > 0) {
      this.setState({ currentImageIndex: currentImageIndex - 1 })
    }
  }

  handleKeyDown = (e) => {
    if (this.state.lightboxOpen) {
      if (e.key === 'Escape') {
        this.closeLightbox()
      } else if (e.key === 'ArrowRight') {
        this.nextImage()
      } else if (e.key === 'ArrowLeft') {
        this.prevImage()
      }
    }
    if (this.state.photoLightboxSrc && e.key === 'Escape') {
      this.closePhotoLightbox()
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown)
    document.body.style.overflow = 'auto'
  }

  render() {
    const { showWindow } = this.props
    const data = this.props?.data || {}
    const page_vars = data?.page_vars || {}
    const page_vars_image = data?.page_vars_image || {}
    const images = data?.images || []

    return (
      <>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.75 16.5H3.75C2.25 16.5 1.5 15.75 1.5 14.25V8.25C1.5 6.75 2.25 6 3.75 6H7.5V14.25C7.5 15.75 8.25 16.5 9.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.58249 3C7.52249 3.225 7.5 3.4725 7.5 3.75V6H3.75V4.5C3.75 3.675 4.425 3 5.25 3H7.58249Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.75 12.75H11.25C10.8375 12.75 10.5 13.0875 10.5 13.5V16.5H13.5V13.5C13.5 13.0875 13.1625 12.75 12.75 12.75Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.5 9.75V12.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 14.25V3.75C7.5 2.25 8.25 1.5 9.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V14.25C16.5 15.75 15.75 16.5 14.25 16.5H9.75C8.25 16.5 7.5 15.75 7.5 14.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>{Parser(page_vars?.block1_plashka || '')}</div>
              </div>
            </div>
            <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
              {Parser(page_vars?.block1_title || '')}
            </h2>
            <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>
              {Parser(page_vars?.block1_text || '')}
            </div>
            <div className='mt-[30px] flex flex-col xl:flex-row gap-[10px] align-middle'>
              <img src={page_vars_image?.block1_img1 || ''} width={359} height={148} className='w-full xl:w-[359px] h-auto flex-none cursor-pointer hover:opacity-90 transition-opacity duration-300' onClick={() => this.openPhotoLightbox(page_vars_image?.block1_img1)} />
              <div className='w-full xl:w-[249px] flex-none xl:min-h-[148px] rounded-[15px] p-[20px] bg-[#032432]'
                style={{
                  backgroundImage: `url("${page_vars_image?.block1_cardbg1 || ''}")`,
                  backgroundSize: 'cover'
                }}
              >
                <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[41px] w-full'>
                  <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 9V7C2 4 4 2 7 2H17C20 2 22 4 22 7V9" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 15V17C2 20 4 22 7 22H17C20 22 22 20 22 17V15" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.69922 9.25977L11.9992 12.3298L17.2592 9.27979" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 17.7703V12.3203" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.7583 6.28957L7.55827 8.0696C6.83827 8.4696 6.23828 9.47959 6.23828 10.3096V13.6996C6.23828 14.5296 6.82827 15.5396 7.55827 15.9396L10.7583 17.7196C11.4383 18.0996 12.5583 18.0996 13.2483 17.7196L16.4483 15.9396C17.1683 15.5396 17.7683 14.5296 17.7683 13.6996V10.3096C17.7683 9.47959 17.1783 8.4696 16.4483 8.0696L13.2483 6.28957C12.5583 5.89957 11.4383 5.89957 10.7583 6.28957Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div>
                    <div className='text-[16px] xl:text-[18px] text-white'>{Parser(page_vars?.block1_card1_title || '')}</div>
                    <div className='mt-[10px] text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(page_vars?.block1_card1_text || '')}</div>
                  </div>
                </div>
              </div>
              <div className='w-full xl:w-[220px] flex-none xl:min-h-[148px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[31px] w-full'>
                  <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.30859 14.7002L10.8086 16.2002L14.8086 12.2002" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 4.01953C19.33 4.19953 21 5.42953 21 9.99953V15.9995C21 19.9995 20 21.9995 15 21.9995H9C4 21.9995 3 19.9995 3 15.9995V9.99953C3 5.43953 4.67 4.19953 8 4.01953" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div>
                    <div className='text-[16px] xl:text-[18px] text-[#032432]'>{Parser(page_vars?.block1_card2_title || '')}</div>
                    <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px]'>{Parser(page_vars?.block1_card2_text || '')}</div>
                  </div>
                </div>
              </div>
              <div className='w-full xl:w-auto flex-1 xl:min-h-[148px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[31px] w-full'>
                  <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.15882 22C3.97882 22 3.13882 19.47 4.49882 16.39L8.74882 6.74H8.44882C7.79882 6.74 7.19882 6.48 6.76882 6.05C6.32882 5.62 6.06882 5.02 6.06882 4.37C6.06882 3.07 7.12882 2 8.43882 2H15.5488C16.2088 2 16.7988 2.27 17.2288 2.7C17.7888 3.26 18.0688 4.08 17.8588 4.95C17.5888 6.03 16.5488 6.74 15.4388 6.74H15.2788L19.4988 16.4C20.8488 19.48 19.9688 22 15.8288 22H8.15882Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.9375 13.1194C5.9375 13.1194 8.9975 12.9994 11.9975 13.9994C14.9975 14.9994 17.8275 13.1094 17.8275 13.1094" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div>
                    <div className='text-[16px] xl:text-[18px] text-[#032432]'>{Parser(page_vars?.block1_card3_title || '')}</div>
                    <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px]'>{Parser(page_vars?.block1_card3_text || '')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='mt-[10px] flex flex-col xl:flex-row gap-[10px] align-middle'>
              <div className='w-full xl:w-auto flex-1 xl:min-h-[219px] rounded-[15px] p-[20px] bg-[#009EE3]'
                style={{
                  backgroundImage: `url("${page_vars_image?.block1_cardbg5 || ''}")`,
                  backgroundSize: 'cover'
                }}
              >
                <div className='flex items-center justify-between'>
                  <div className='text-[16px] xl:text-[18px] text-white'>{Parser(page_vars?.block1_card4_title || '')}</div>
                  <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.88281 18.1501V16.0801" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M12 18.1498V14.0098" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M17.1172 18.1497V11.9297" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M17.1228 5.84961L16.6628 6.38961C14.1128 9.36961 10.6928 11.4796 6.88281 12.4296" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M14.1875 5.84961H17.1175V8.76961" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div className='mt-[7px] text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>
                  {Parser(page_vars?.block1_card4_text || '')}
                </div>
                <div className='p-[15px] bg-white rounded-[10px] mt-[10px]'>
                  <div className='flex items-center justify-start gap-[7px]'>
                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.75 5.75C3.85457 5.75 4.75 4.85457 4.75 3.75C4.75 2.64543 3.85457 1.75 2.75 1.75C1.64543 1.75 0.75 2.64543 0.75 3.75C0.75 4.85457 1.64543 5.75 2.75 5.75Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.75 5.75C21.8546 5.75 22.75 4.85457 22.75 3.75C22.75 2.64543 21.8546 1.75 20.75 1.75C19.6454 1.75 18.75 2.64543 18.75 3.75C18.75 4.85457 19.6454 5.75 20.75 5.75Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M18.75 3.75H14.75" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.75 3.75H4.75" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7.25 13.25V15.25C7.25 15.86 6.88 16.39 6.36 16.61C6.17 16.7 5.97 16.75 5.75 16.75H3.75C2.92 16.75 2.25 16.08 2.25 15.25V13.25C2.25 12.42 2.92 11.75 3.75 11.75H5.75C6.58 11.75 7.25 12.42 7.25 13.25Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21.25 13.25V15.25C21.25 16.08 20.58 16.75 19.75 16.75H17.75C17.53 16.75 17.33 16.7 17.14 16.61C16.62 16.39 16.25 15.86 16.25 15.25V13.25C16.25 12.42 16.92 11.75 17.75 11.75H19.75C20.58 11.75 21.25 12.42 21.25 13.25Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.75 2.25V5.25C14.75 6.07 14.07 6.75 13.25 6.75H10.25C9.43 6.75 8.75 6.07 8.75 5.25V2.25C8.75 1.43 9.43 0.75 10.25 0.75H13.25C14.07 0.75 14.75 1.43 14.75 2.25Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.75 4.48047C17.12 5.68047 18.75 8.26049 18.75 11.2505C18.75 11.4205 18.74 11.5805 18.72 11.7505" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M4.78 11.7505C4.76 11.5805 4.75 11.4205 4.75 11.2505C4.75 8.26049 6.38 5.68047 8.75 4.48047" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className='text-[16px] xl:text-[18px] text-[#032432]'>{Parser(page_vars?.block1_card4_title2 || '')}</div>
                  </div>
                  <div className='mt-[10px] text-[#032432]/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>
                    {Parser(page_vars?.block1_card4_text2 || '')}
                  </div>
                </div>
              </div>
              <img src={page_vars_image?.block1_img2 || ''} width={528} height={219} className='w-full xl:w-[528px] h-auto flex-none cursor-pointer hover:opacity-90 transition-opacity duration-300' onClick={() => this.openPhotoLightbox(page_vars_image?.block1_img2)} />
            </div>
          </div>
        </div>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.75 5.25V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V5.25C2.25 3 3.375 1.5 6 1.5H12C14.625 1.5 15.75 3 15.75 5.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.875 3.375V4.875C10.875 5.7 11.55 6.375 12.375 6.375H13.875" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 9.75H9" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 12.75H12" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>{Parser(page_vars?.block2_plashka || '')}</div>
              </div>
            </div>
            <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
              {Parser(page_vars?.block2_title || '')}
            </h2>
            <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>
              {Parser(page_vars?.block2_text || '')}
            </div>
            <div className='mt-[30px] flex flex-col xl:flex-row gap-[10px]'>
              <div className='flex-1'>
                <div className='flex flex-col xl:flex-row gap-[10px] align-middle'>
                  <div className='w-full xl:w-[302px] flex-none xl:min-h-[178px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[31px] w-full'>
                      <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1103 11.1494H7.4603C6.8303 11.1494 6.32031 11.6594 6.32031 12.2894V17.4094H10.1103V11.1494V11.1494Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.7616 6.59961H11.2415C10.6115 6.59961 10.1016 7.10962 10.1016 7.73962V17.3997H13.8916V7.73962C13.8916 7.10962 13.3916 6.59961 12.7616 6.59961Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5484 12.8496H13.8984V17.3997H17.6884V13.9896C17.6784 13.3596 17.1684 12.8496 16.5484 12.8496Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div>
                        <div className='text-[16px] xl:text-[18px] text-[#032432]'>{Parser(page_vars?.block2_card1_title || '')}</div>
                        <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px]'>{Parser(page_vars?.block2_card1_text || '')}</div>
                      </div>
                    </div>
                  </div>
                  <div className='w-full xl:w-auto flex-1 xl:min-h-[178px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'>
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[31px] w-full'>
                      <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.6602 10.4395L20.6802 14.6195C19.8402 18.2295 18.1802 19.6895 15.0602 19.3895C14.5602 19.3495 14.0202 19.2595 13.4402 19.1195L11.7602 18.7195C7.59018 17.7295 6.30018 15.6695 7.28018 11.4895L8.26018 7.29952C8.46018 6.44952 8.70018 5.70952 9.00018 5.09952C10.1702 2.67952 12.1602 2.02952 15.5002 2.81952L17.1702 3.20952C21.3602 4.18952 22.6402 6.25952 21.6602 10.4395Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.0584 19.3896C14.4384 19.8096 13.6584 20.1596 12.7084 20.4696L11.1284 20.9896C7.15839 22.2696 5.06839 21.1996 3.77839 17.2296L2.49839 13.2796C1.21839 9.30961 2.27839 7.20961 6.24839 5.92961L7.82839 5.40961C8.23839 5.27961 8.62839 5.16961 8.99839 5.09961C8.69839 5.70961 8.45839 6.44961 8.25839 7.29961L7.27839 11.4896C6.29839 15.6696 7.58839 17.7296 11.7584 18.7196L13.4384 19.1196C14.0184 19.2596 14.5584 19.3496 15.0584 19.3896Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.6406 8.53027L17.4906 9.76027" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.6602 12.4004L14.5602 13.1404" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div>
                        <div className='text-[16px] xl:text-[18px] text-[#032432]'>{Parser(page_vars?.block2_card2_title || '')}</div>
                        <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px]'>{Parser(page_vars?.block2_card2_text || '')}</div>
                      </div>
                    </div>
                  </div>
                  <div className='w-full xl:w-[314px] flex-none xl:min-h-[178px] rounded-[15px] p-[20px] bg-[#032432]'
                    style={{
                      backgroundImage: `url("${page_vars_image?.block2_cardbg1 || ''}")`,
                      backgroundSize: 'cover'
                    }}
                  >
                    <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[41px] w-full'>
                      <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.7489 2.45031C11.4389 1.86031 12.5689 1.86031 13.2689 2.45031L14.8489 3.81042C15.1489 4.07042 15.7089 4.28039 16.1089 4.28039H17.8089C18.8689 4.28039 19.7389 5.15032 19.7389 6.21032V7.9104C19.7389 8.3004 19.9489 8.87041 20.2089 9.17041L21.5689 10.7504C22.1589 11.4404 22.1589 12.5704 21.5689 13.2704L20.2089 14.8503C19.9489 15.1503 19.7389 15.7103 19.7389 16.1103V17.8104C19.7389 18.8704 18.8689 19.7404 17.8089 19.7404H16.1089C15.7189 19.7404 15.1489 19.9503 14.8489 20.2103L13.2689 21.5703C12.5789 22.1603 11.4489 22.1603 10.7489 21.5703L9.16892 20.2103C8.86892 19.9503 8.30891 19.7404 7.90891 19.7404H6.1789C5.1189 19.7404 4.2489 18.8704 4.2489 17.8104V16.1003C4.2489 15.7103 4.03891 15.1503 3.78891 14.8503L2.43891 13.2604C1.85891 12.5704 1.85891 11.4504 2.43891 10.7604L3.78891 9.17041C4.03891 8.87041 4.2489 8.31041 4.2489 7.92041V6.21032C4.2489 5.15032 5.1189 4.28039 6.1789 4.28039H7.90891C8.29891 4.28039 8.86892 4.07042 9.16892 3.81042L10.7489 2.45031Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.89111 14.82L11.3411 15.94C11.5311 16.13 11.9511 16.22 12.2311 16.22H14.0011C14.5611 16.22 15.1711 15.8 15.3111 15.24L16.4311 11.82C16.6611 11.17 16.2411 10.6 15.5411 10.6H13.6711C13.3911 10.6 13.1611 10.3701 13.2011 10.0401L13.4311 8.54008C13.5211 8.12008 13.2411 7.65005 12.8211 7.51005C12.4511 7.37005 11.9811 7.56 11.7911 7.84L9.87109 10.69" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10"/>
                        <path d="M7.5 14.8196V10.2396C7.5 9.57962 7.78 9.34961 8.44 9.34961H8.91C9.56 9.34961 9.85001 9.57962 9.85001 10.2396V14.8196C9.85001 15.4696 9.57 15.7096 8.91 15.7096H8.44C7.78 15.7096 7.5 15.4796 7.5 14.8196Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div>
                        <div className='text-[16px] xl:text-[18px] text-white'>{Parser(page_vars?.block2_card3_title || '')}</div>
                        <div className='mt-[10px] text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(page_vars?.block2_card3_text || '')}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='mt-[10px] flex flex-col xl:flex-row gap-[10px] align-middle'>
                  <img src={page_vars_image?.block4_img2 || ''} width={355} height={181} className='w-full xl:w-[355px] h-auto flex-none cursor-pointer hover:opacity-90 transition-opacity duration-300' onClick={() => this.openPhotoLightbox(page_vars_image?.block4_img2)} />
                  <div className='w-full xl:w-auto flex-1 xl:min-h-[181px] rounded-[15px] p-[20px] bg-[#009EE3]'
                    style={{
                      backgroundImage: `url("${page_vars_image?.block2_cardbg5 || ''}")`,
                      backgroundSize: 'cover'
                    }}
                  >
                    <div className='flex justify-between items-start'>
                      <h3 className='font-medium text-[24px] xl:text-[36px] text-white'>{Parser(page_vars?.block2_card4_title || '')}</h3>
                      <img className='hidden xl:block' src={data?.slogo} width={50} height={50} alt='logo' />
                    </div>
                    <div className='flex justify-between flex-col xl:flex-row items-start xl:items-center mt-[10px] gap-[20px] xl:gap-[26px]'>
                      <div className='text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(page_vars?.block2_card4_text || '')}</div>
                      <div className='w-full xl:w-auto flex justify-between gap-[10px]'>
                        <div onClick={() => showWindow()} className='flex flex-1 items-center justify-center gap-[9px] h-[38px] xl:h-[50px] px-[19px] bg-white text-black rounded-full cursor-pointer'>
                          <div className='text-[14px] xl:text-[16px]'>Связаться</div>
                          <ChevronIcon2 stroke="black" />
                        </div>
                        <img src={data?.slogo} alt='slogo' width={38} height={38} className='xl:hidden flex-none' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img src={page_vars_image?.block2_img6 || ''} width={174} height={369} className='w-full xl:w-[174px] h-[190px] xl:h-auto object-cover flex-none rounded-[15px] cursor-pointer hover:opacity-90 transition-opacity duration-300' onClick={() => this.openPhotoLightbox(page_vars_image?.block2_img6)} />
            </div>
          </div>
        </div>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.16406 13.613V12.0605" stroke="#032432" stroke-width="1.125" stroke-linecap="round"/>
                  <path d="M9 13.6128V10.5078" stroke="#032432" stroke-width="1.125" stroke-linecap="round"/>
                  <path d="M12.8359 13.6123V8.94727" stroke="#032432" stroke-width="1.125" stroke-linecap="round"/>
                  <path d="M12.8441 4.38672L12.4991 4.79172C10.5866 7.02672 8.02156 8.60922 5.16406 9.32172" stroke="#032432" stroke-width="1.125" stroke-linecap="round"/>
                  <path d="M10.6406 4.38672H12.8381V6.57672" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>{Parser(page_vars?.block3_plashka || '')}</div>
              </div>
            </div>
            <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>
              {Parser(page_vars?.block3_title || '')}
            </h2>
            <div className='flex items-center justify-between'>
              <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>
                {Parser(page_vars?.block3_text || '')}
              </div>
              <div className='hidden xl:flex items-center gap-[5px]'>
                <div
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    this.state.isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !this.state.isBeginning && this.swiperRef.current?.slidePrev()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="white"/>
                  </svg>
                </div>
                <div
                  className={`w-[38px] h-[38px] rounded-full bg-[#032432] cursor-pointer flex items-center justify-center transition-opacity duration-300 ${
                    this.state.isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-opacity-80'
                  }`}
                  onClick={() => !this.state.isEnd && this.swiperRef.current?.slideNext()}
                >
                  <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="white"/>
                  </svg>
                </div>
              </div>
            </div>
            {/* Слайдер изображений */}
            <div className='mt-[30px]'>
              <Swiper
                onSwiper={(swiper) => {
                  this.swiperRef.current = swiper
                  this.handleSlideChange(swiper)
                }}
                onSlideChange={this.handleSlideChange}
                modules={[Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                breakpoints={{
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 10
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 10
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 10
                  }
                }}
                className='invest-slider'
              >
                {images.map((elm, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className='rounded-[15px] overflow-hidden cursor-pointer'
                      onClick={() => this.openLightbox(index)}
                    >
                      <img
                        src={elm.image}
                        alt={elm.name || `Фото ${index + 1}`}
                        width={228}
                        height={247}
                        className='h-auto w-full object-cover'
                        loading="lazy"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div 
              className='mt-[10px] w-full bg-[#032432] rounded-[15px] p-[20px] flex flex-col xl:flex-row gap-[10px]'
              style={{
                backgroundImage: `url("${page_vars_image?.block3_cardbg1 || ''}")`,
                backgroundSize: 'cover'
              }}
            >
              <div className='flex-1 flex flex-col items-start gap-[10px]'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7289 3.50965L15.4889 7.02965C15.7289 7.51965 16.3689 7.98965 16.9089 8.07965L20.0989 8.60965C22.1389 8.94965 22.6189 10.4296 21.1489 11.8896L18.6689 14.3696C18.2489 14.7896 18.0189 15.5996 18.1489 16.1796L18.8589 19.2496C19.4189 21.6796 18.1289 22.6196 15.9789 21.3496L12.9889 19.5796C12.4489 19.2596 11.5589 19.2596 11.0089 19.5796L8.01893 21.3496C5.87893 22.6196 4.57893 21.6696 5.13893 19.2496L5.84893 16.1796C5.97893 15.5996 5.74893 14.7896 5.32893 14.3696L2.84893 11.8896C1.38893 10.4296 1.85893 8.94965 3.89893 8.60965L7.08893 8.07965C7.61893 7.98965 8.25893 7.51965 8.49893 7.02965L10.2589 3.50965C11.2189 1.59965 12.7789 1.59965 13.7289 3.50965Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='mt-auto text-white text-[18px]'>Посмотрите, как развивается проект</div>
                <div className='mt-[10px] text-white/60 text-[14px]'>
                  В видео представлен проект будущего производственного комплекса: планировка территории, расположение зданий и общее устройство новой производственной площадки.
                </div>
              </div>
              <div
                onClick={this.openVideoModal}
                className='relative cursor-pointer group flex-none'
              >
                <div className='absolute flex w-full h-full top-0 left-0 items-center justify-center z-10 group-hover:scale-110 transition-transform duration-300'>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill="#009EE3"/>
                    <path d="M11.25 15.0012V12.9547C11.25 10.3135 12.9878 9.2487 15.1117 10.5624L16.7594 11.5857L18.407 12.609C20.531 13.9226 20.531 16.0798 18.407 17.3935L16.7594 18.4168L15.1117 19.4401C12.9878 20.7538 11.25 19.6752 11.25 17.0478V15.0012Z" fill="white"/>
                  </svg>
                </div>
                <img src={page_vars_image?.block3_img1 || ''} alt='' width={430} height={225} className='w-full xl:w-[430px] h-auto group-hover:opacity-90 transition-opacity duration-300 rounded-[15px]' />
              </div>
              <div className='bg-white rounded-[15px] p-[15px] flex-none w-full xl:w-[385px]'>
                <div className='text-black/60 text-[14px]'>
                  Строительство производственного комплекса позволит компании значительно нарастить объёмы выпуска, расширить ассортимент химической продукции и усилить позиции на рынке бытовой и промышленной химии.
                </div>
                <img src={page_vars_image?.block3_img2 || ''} alt='' width={355} height={105} className='w-full mt-[15px] cursor-pointer hover:opacity-90 transition-opacity duration-300' onClick={() => this.openPhotoLightbox(page_vars_image?.block3_img2)} />
              </div>
            </div>
          </div>
        </div>

        {/* Модальное окно с видео */}
        {this.state.isVideoModalOpen && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
            onClick={this.closeVideoModal}
          >
            <div
              className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Кнопка закрытия */}
              <button
                onClick={this.closeVideoModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 flex items-center justify-center transition-colors duration-200"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              {/* Видео iframe */}
              <div className="relative pt-[56.25%]">
                <iframe
                  src={(() => {
                    const videoId = this.getRutubeVideoId('https://rutube.ru/video/027edefefe1734c93179e3b8fc8f4a59/?r=wd')
                    return videoId ? `https://rutube.ru/play/embed/${videoId}` : ''
                  })()}
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Rutube video player"
                />
              </div>
            </div>
          </div>
        )}

        {/* Lightbox для увеличения изображения */}
        {this.state.lightboxOpen && (
          <div
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {this.state.currentImageIndex > 0 && (
              <button
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.prevImage()
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={images[this.state.currentImageIndex]?.image}
                alt={images[this.state.currentImageIndex]?.name || 'Увеличенное фото'}
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Счетчик */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm'>
                <span>{this.state.currentImageIndex + 1} / {images.length}</span>
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {this.state.currentImageIndex < images.length - 1 && (
              <button
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10'
                onClick={(e) => {
                  e.stopPropagation()
                  this.nextImage()
                }}
              >
                ›
              </button>
            )}
          </div>
        )}

        {/* Lightbox для увеличения одиночных фото */}
        {this.state.photoLightboxSrc && (
          <div
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closePhotoLightbox}
          >
            {/* Кнопка закрытия */}
            <button
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black bg-opacity-50 hover:bg-opacity-70 transition-all'
              onClick={this.closePhotoLightbox}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Изображение */}
            <div
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={this.state.photoLightboxSrc}
                alt='Увеличенное фото'
                className='max-w-full max-h-[90vh] object-contain'
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default App